import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared';
import {
  IGetArticleListRequest,
  IGetArticleListResponse,
  // IGetArticleListResponseError,
  IMappers,
  TGetArticleListModel, TGetArticleListResponse
} from './types';

export const defaultConfig: TGetArticleListModel = {
  apiType: 'legacy',
  assertStatusCodes: [200],
  method: 'GET',
  microserviceName: 'backendContent',
  pathApi: '/v1/get-article-list',
};

export function createGetArticleListModel(parameters: IGetArticleListRequest): TGetArticleListModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetArticleListOptions<TResponse200> {
  httpApi: IHttpApi;
  parameters: IGetArticleListRequest;
  mappers: IMappers<TResponse200>;
  config?: IHttpApiFetchConfig;
}

export async function fetchGetArticleList<TResponse200>({
  httpApi,
  parameters,
  mappers,
  config,
}: IGetArticleListOptions<TResponse200>): Promise<
  TResponse200 | TGetArticleListResponse
> {
  try {
    let {response, statusCode} = await httpApi.fetch(createGetArticleListModel(parameters), config);

    if (mappers && statusCode in mappers) {
      if (statusCode === 200) {
        return mappers[200](response as IGetArticleListResponse);
      }

      // if (statusCode === 400) {
      //   return mappers[400](response as IGetArticleListResponseError);
      // }
    }

    return {response, statusCode} as TGetArticleListResponse;
  } catch (e) {
    return {response: e, statusCode: 200} as TGetArticleListResponse;
  }


}
